import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartBar,
  faChartPie,
  faChartLine,
  faTable
} from '@fortawesome/free-solid-svg-icons';
import './index.css';

// Map visualization types to FontAwesome icons
const vizIconMap = {
  barchart:        faChartBar,
  piechart:        faChartPie,
  linechart:       faChartLine,
  'sn-pivot-table': faTable,
  pivot:           faTable,
  table:           faTable
};

export default function ExportDataSelectorModal({
  exportSelectObjectText = 'Select chart to export',
  exportNoObjectText   = 'No available objects to export.',
  options,
  onSelect,
  onClose,
  closeBtnText = 'Close'
}) {
  return (
    <div 
      className="modal fade show modal-black-back selector-modal" 
      style={{ display: 'block' }} 
      aria-modal="true" 
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              <i className="lui-icon lui-icon--large lui-icon--download" />{' '}
              {exportSelectObjectText}
            </h4>
          </div>
          <div className="modal-body">
            {options && options.length > 0 ? (
              <ul className="selector-list">
                {options.map(opt => {
                  const icon = vizIconMap[opt.vizType] || faChartBar;
                  return (
                    <li key={opt.qId} className="selector-item">
                      <button
                        type="button"
                        className="selector-button"
                        onClick={() => onSelect(opt.qId)}
                      >
                        <FontAwesomeIcon
                          icon={icon}
                          fixedWidth
                          className="selector-icon"
                        />
                        <span className="selector-text">{opt.title}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="selector-warning">
                {exportNoObjectText}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary btn-success"
              onClick={onClose}
            >
              {closeBtnText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
